const RANKING_ITEMS = [
  { rank: 1, title: '鬼刀之风起', type: '国漫·古风', heat: '本周最热', desc: '继鬼刀之后又一古风力作，画风精美到每一帧都能当壁纸，剧情层层递进引人入胜。', badge: 'TOP 1', badgeColor: 'bg-accent-500 text-background-50' },
  { rank: 2, title: '我的野蛮女友·漫画版', type: '韩漫·纯爱', heat: '人气飙升', desc: '经典IP改编漫画，甜蜜与搞笑并存，每周更新总能让人又哭又笑。', badge: '飙升', badgeColor: 'bg-primary-500 text-background-50' },
  { rank: 3, title: '咒术回战·番外篇', type: '日漫·热血', heat: '讨论爆表', desc: '正篇之外的精彩外传，补全了主要角色的过去故事，战斗场面丝毫不输正篇。', badge: '热门', badgeColor: 'bg-accent-500 text-background-50' },
  { rank: 4, title: '大理寺日志·第三季', type: '国漫·悬疑', heat: '持续追更', desc: '古风悬疑巅峰之作，每一季都在突破前作的水平，推理爱好者必追。', badge: '推荐', badgeColor: 'bg-secondary-500 text-background-50' },
  { rank: 5, title: '某天成为公主', type: '韩漫·奇幻', heat: '口碑佳作', desc: '转生题材中的清流，剧情不落俗套，人物塑造细腻立体，是奇幻分类中的宝藏作品。', badge: '好评', badgeColor: 'bg-primary-500 text-background-50' },
  { rank: 6, title: '一人之下·新章', type: '国漫·玄幻', heat: '重磅回归', desc: '万众期待的新篇章终于开启，世界观进一步扩展，新角色登场引发漫友热议。', badge: '重磅', badgeColor: 'bg-accent-500 text-background-50' },
  { rank: 7, title: '宅男的真爱字典', type: '日漫·搞笑', heat: '轻松首选', desc: '社恐宅男的恋爱喜剧，每一话都让人捧腹大笑，是工作日午休的最佳伴侣。', badge: '轻松', badgeColor: 'bg-secondary-500 text-background-50' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          新新热门榜
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          基于热度、更新频率与漫友讨论度综合排序
        </p>
        <div className="space-y-3 md:space-y-4">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/80 hover:border-primary-200 transition-colors"
            >
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className={`w-8 h-8 rounded-full flex items-center justify-center font-extrabold text-[14px] ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </span>
                <span className={`px-2 py-0.5 rounded text-[11px] font-bold ${item.badgeColor} whitespace-nowrap`}>
                  {item.badge}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <h3 className="text-[15px] md:text-[16px] font-bold text-foreground-900">{item.title}</h3>
                  <span className="text-[12px] text-primary-500 font-medium whitespace-nowrap">{item.type}</span>
                </div>
                <p className="text-[13px] text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
              <span className="text-[13px] font-semibold text-accent-500 whitespace-nowrap flex-shrink-0 flex items-center gap-1">
                <i className="ri-fire-line"></i>
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}